"use strict";

module.exports = {
  INSERT: 'INSERT',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  UPSERT: 'UPSERT',
  NOTIFICATION_UPDATE: 'NOTIFICATION_UPDATE'
};